import { Profile, ProfilesAllResponse } from "app/types/configuracion/perfiles";
import { toaster } from "app/utilities/commons";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

export async function getAllProfiles(page: number | string, pageSize: number | string) {
  try {
    const response = await axios.get<ProfilesAllResponse>(`${API_URL}Profile?Page=${page}&PageSize=${pageSize}`);
    return response.data.data;
  } catch (err) {
    console.error("Error:", err);
    throw err;
  }
}

export async function getAllProfilesFilterCode(page: number | string, pageSize: number | string, code?: string) {
  try {
    const response = await axios.get<ProfilesAllResponse>(`${API_URL}Profile?Code=${code}&Page=${page}&PageSize=${pageSize}`);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching filter code");
    throw err;
  }
}

export async function getAllProfilesFilterDesc(page: number | string, pageSize: number | string, description?: string) {
  try {
    const response = await axios.get<ProfilesAllResponse>(`${API_URL}Profile?Description=${description}&Page=${page}&PageSize=${pageSize}`);
    return response.data.data;
  } catch (err) {
    console.error("Error fetching filter description");
    throw err;
  }
}

export async function profileCreateAndUpdate(body: Profile) {
  let response;
  const { code, description, idDepartament ,status, id } = body;

  if (id) {
    try {
      response = await axios.put(`${API_URL}Profile/${id}`, {
        code,
        description,
        status,
        idDepartament,
        id
      });

      toaster.success('Se cambio con éxito la información');
      return response.data;
    } catch (err) {
      console.error("ERROR UPDATING profile: ", err);
      throw err;
    }
  } else {
    try {
      response = await axios.post(`${API_URL}Profile`, {
        code,
        description,
        status,
        idDepartament,
      })
      toaster.success("Guardado correctamente");
      return response.data;
    } catch (err) {
      console.error("ERROR CREATING profile: ", err);
      throw err;
    }
  }
}